(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CareTeamSpecialtySearch', CareTeamSpecialtySearch);

    CareTeamSpecialtySearch.$inject = ['$resource'];

    function CareTeamSpecialtySearch($resource) {
        var resourceUrl =  'api/_search/care-team-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
